import React from "react";
import { BsFacebook, BsInstagram } from "react-icons/bs";
import { HiOutlineMail } from "react-icons/hi";
import Map from "../components/Map";
import Footer from "./Footer";

const Contact = () => {
  return (
    <div id="contact" className="flex justify-center text-white pt-2">
      <div className="bg-[#2f1847] w-full max-w-screen-lg">
        <div className="px-3">
          <h1 className="text-[#FF0080] text-4xl py-5">Get in touch</h1>
        </div>
        <div className="px-3">
          <p>
            Give me a call on{" "}
            <a
              href="tel:01234555666"
              className="inline-block text-xl tracking-wide"
            >
              01234 555 666
            </a>{" "}
            or alternatively get in touch using one of the methods below:
          </p>
        </div>
        {/* contact cards container */}
        <div className="pb-4 px-3">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {/* facebook card */}
            <div className="flex flex-col items-center justify-center">
              <BsFacebook className="m-6 text-5xl bg-[#FF0080] rounded-full p-1" />
              <div className="border-2 p-2 border-white hover:border-[#FF0080]">
                <a
                  href="https://www.facebook.com/profile.php?id=100054614102774"
                  target="blank"
                  className="p-2"
                >
                  Facebook
                </a>
              </div>
            </div>
            {/* instagram card */}
            <div className="flex flex-col items-center justify-center">
              <BsInstagram className="m-6 text-5xl bg-[#FF0080] rounded-full p-1" />
              <div className="border-2 p-2 border-white hover:border-[#FF0080]">
                <a
                  href="https://www.instagram.com/canteabianca/"
                  target="blank"
                  className="p-2"
                >
                  Instagram
                </a>
              </div>
            </div>
            {/* email */}
            {/* <button className="">
              <span className="w-0 h-0 rounded bg-[#FF0080] absolute top-0 left-0 ease-out duration-500 transition-all group-hover:w-full group-hover:h-full -z-1"></span>{" "}
            </button> */}
            <div className="flex flex-col items-center justify-center">
              <HiOutlineMail className="m-6 text-5xl bg-[#FF0080] rounded-full p-1" />
              <div className="border-2 p-2 border-white hover:border-[#FF0080]">
                <a
                  href="mailto:canteabianca462@gmail.com?subject=Mail from website"
                  target="_blank"
                  rel="noreferrer"
                  className="p-2"
                >
                  Email
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="pb-4 px-3">
          <h1 className="text-[#FF0080] text-4xl py-5">Location</h1>
          {/* <p>59 Clonuske Park</p> */}
          <p>Bremore, Balbriggan</p>
          <p>County Dublin</p>
          <p>K32 F720</p>
        </div>
        <div className="pb-2">
          <Map />
        </div>
        <div className="pt-2">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Contact;
